import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CONTACT, NAV_LINKS } from "@/data/content";

const FooterCta = () => (
    <Reveal className="lg:col-span-7">
        <div className="flex items-center gap-4">
            <span className="h-px w-10 bg-gold/50" />
            <span className="text-xs uppercase tracking-[0.25em] text-gold">Begin Your Journey</span>
        </div>
        <h2 data-testid="cta-section-heading" className="mt-8 font-serif text-4xl font-light leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl">
            Let’s Create Something <em className="text-gold">Personal.</em>
        </h2>
        <div className="mt-10 flex flex-wrap items-center gap-6">
            <a
                data-testid="footer-whatsapp-btn"
                href={CONTACT.whatsappHref}
                target="_blank"
                rel="noreferrer"
                className="group inline-flex items-center gap-3 rounded-full bg-gold px-7 py-3.5 text-xs uppercase tracking-[0.2em] text-night transition-colors duration-300 hover:bg-ivory"
            >
                WhatsApp the Studio
                <span className="h-1.5 w-1.5 rotate-45 bg-night transition-transform duration-300 group-hover:rotate-[135deg]" />
            </a>
            <Link data-testid="footer-contact-link" to="/contact" className="group inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-ivory/70 transition-colors hover:text-gold">
                All ways to reach us
                <ArrowUpRight size={14} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
        </div>
    </Reveal>
);

const FooterLinks = () => (
    <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/40">Explore</p>
        <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
                <li key={l.to}>
                    <Link to={l.to} data-testid={`footer-${l.testid}`} className="font-serif text-lg text-ivory/80 transition-colors hover:text-gold">
                        {l.label}
                    </Link>
                </li>
            ))}
        </ul>
    </div>
);

const FooterReach = () => (
    <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/40">Reach</p>
        <ul className="mt-5 space-y-3 text-sm font-light text-ivory/80">
            <li><a href={CONTACT.phoneHref} className="transition-colors hover:text-gold">{CONTACT.phoneDisplay}</a></li>
            <li><a href={CONTACT.emailHref} className="break-all transition-colors hover:text-gold">{CONTACT.email}</a></li>
            <li><a href={CONTACT.instagramHref} target="_blank" rel="noreferrer" className="transition-colors hover:text-gold">{CONTACT.instagram}</a></li>
            <li className="pt-2 text-ivory/50">Kolkata, West Bengal</li>
        </ul>
    </div>
);

const FooterCopyright = () => (
    <div className="mt-16 flex flex-col gap-8 border-t border-ivory/10 pt-10 md:flex-row md:items-center md:justify-between">
        <img src="/brand/logo-transparent.png" alt="Noir Nest — Interior Company" data-testid="footer-brand-logo" className="h-28 w-auto lg:h-32" />
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/40">Conceived Together. Engineered Forever.</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/40">© 2026 Noir Nest — Kolkata, India</p>
    </div>
);

export const Footer = () => (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-night text-ivory">
        <span aria-hidden className="pointer-events-none absolute -bottom-16 -left-6 select-none font-serif text-[12rem] italic leading-none text-ivory/[0.03] lg:text-[20rem]">
            Nest
        </span>
        <div className="relative mx-auto max-w-7xl px-6 py-20 sm:px-12 lg:px-20 lg:py-28">
            <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
                <FooterCta />
                <Reveal delay={0.15} className="grid grid-cols-2 gap-10 lg:col-span-5">
                    <FooterLinks />
                    <FooterReach />
                </Reveal>
            </div>
            <FooterCopyright />
        </div>
    </footer>
);
